import { render, staticRenderFns } from "./revisaoCamposItem.vue?vue&type=template&id=174d972a"
import script from "./revisaoCamposItem.ts?vue&type=script&lang=js&external"
export * from "./revisaoCamposItem.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174d972a')) {
      api.createRecord('174d972a', component.options)
    } else {
      api.reload('174d972a', component.options)
    }
    module.hot.accept("./revisaoCamposItem.vue?vue&type=template&id=174d972a", function () {
      api.rerender('174d972a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/revisaoCamposItem.vue"
export default component.exports